export const SpecialPage = () => {
    return (
        <div>
            If you are logged in, it means you can see me!
        </div>
    )
    
}